export const getVersion = '00000081000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000'
export const beforeValue = "00 03 00 a5 02";
export const afterValue =
  "00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00000000";
// export const defaultValue = [
//   "01 00 f0 00",
//   "01 00 f1 00",
//   "01 00 f2 00",
//   "01 00 f3 00",
//   "01 00 f4 00",
//   "0f 00 03 00",
//   "0f 00 03 00",
//   "01 00 f8 01",
//   "01 00 f8 ff",
// ];
export const buttonKey = [
  [
    "0100F000",
    "0100F100",
    "0100F200",
    "0100f400",
    "0100f300",
    "0100f900",
    "0100f801",
    "0100f8ff",

    "0100f500",
    "0100f600",
  ],
  ["07000300", "07000100", "07000200"],
  [
    "0300E900",
    "0300EA00",
    "0300E200",
    "03008301",
    "0300CD00",
    "0300B600",
    "0300B500",
    "0300B700",
  ],
  [
    "03006f00",
    "03007000",
    "03009201",
    "03009401",
    "03002302",
    "03008A01",
    "00003e00",
    "0a010000",
    "00010600",
    "00011b00",
    "00011900",
  ],
];

export const saveData =
  "000a0081010000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
export const readMouseData =
  "00 03 00 81 01 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 ";

export const options = [
  {
    id: 0,
    label: "按键1 左键",
    key: 0,
    _label: "按键1 左键",
  },
  {
    id: 1,
    label: "按键2 右键",
    key: 1,
    _label: "按键2 右键",
  },
  {
    id: 2,
    label: "按键3 中键",
    key: 2,
    _label: "按键3 中键",
  },
  {
    id: 4,
    label: "按键4 前进",
    key: 4,
    _label: "按键4 前进",
  },
  {
    id: 3,
    label: "按键5 后退",
    key: 3,
    _label: "按键5 后退",
  },
  {
    id: 7,
    label: "滚轮上 向上滚动",
    key: 5,
    _label: "滚轮上 向上滚动",
  },
  {
    id: 8,
    label: "滚轮下 向下滚动",
    key: 6,
    _label: "滚轮下 向下滚动",
  },
];

export const basekey = [
  [
    { idx: 0, value: "左键" },
    { idx: 1, value: "右键" },
    { idx: 2, value: "中键" },
  ],
  [
    { idx: 3, value: "前进" },
    { idx: 4, value: "后退" },
    { idx: 5, value: "左键双击" },
  ],
  [
    { idx: 6, value: "向上滚动" },
    { idx: 7, value: "向下滚动" },
    { idx: 8, value: "向左滚动" },
  ],
  [{ idx: 9, value: "向右滚动" }],
];
export const otherLanguageKey = [
  [
    { idx: 0, value: "左键" },
    { idx: 1, value: "右键" },
  ],
  [
    { idx: 2, value: "中键" },
    { idx: 3, value: "前进" },
  ],
  [
    { idx: 4, value: "后退" },
    { idx: 5, value: "左键双击" },
  ],
  [
    { idx: 6, value: "向上滚动" },
    { idx: 7, value: "向下滚动" },
  ],
  [
    { idx: 8, value: "向左滚动" },
    { idx: 9, value: "向右滚动" },
  ],
];
export const dpiLoop = [
  [
    { idx: 0, value: "DPI Loop" },
    { idx: 1, value: "DPI+" },
    { idx: 2, value: "DPI-" },
  ],
];
export const mediaKey = [
  [
    { idx: 0, value: "音量+" },
    { idx: 1, value: "音量-" },
    { idx: 2, value: "静音" },
  ],

  [
    { idx: 3, value: "播放器" },
    { idx: 4, value: "播放/暂停" },
    { idx: 5, value: "上一首" },
  ],
  [
    { idx: 6, value: "下一首" },
    { idx: 7, value: "停止播放" },
  ],
];
export const otherLanguageMediaKey = [
  [
    { idx: 0, value: "音量+" },
    { idx: 1, value: "音量-" },
  ],

  [
    { idx: 2, value: "静音" },
    { idx: 3, value: "播放器" },
  ],
  [
    { idx: 4, value: "播放/暂停" },
    { idx: 5, value: "上一首" },
  ],
  [
    { idx: 6, value: "下一首" },
    { idx: 7, value: "停止播放" },
  ],
];
export const otherLanguageSystemKey = [
  [
    { idx: 0, value: "屏幕亮度+" },
    { idx: 1, value: "屏幕亮度-" },
  ],
  [
    { idx: 2, value: "启动计算器" },
    { idx: 3, value: "我的电脑" },
  ],
  [
    { idx: 4, value: "打开主页" },
    { idx: 5, value: "邮件" },
  ],
  [
    { idx: 6, value: "刷新" },
    { idx: 7, value: "切换应用" },
  ],
  [
    { idx: 8, value: "复制" },
    { idx: 9, value: "剪切" },
  ],
  [{ idx: 10, value: "粘贴" }],
];
export const systemKey = [
  [
    { idx: 0, value: "屏幕亮度+" },
    { idx: 1, value: "屏幕亮度-" },
    { idx: 2, value: "启动计算器" },
  ],
  [
    { idx: 3, value: "我的电脑" },
    { idx: 4, value: "打开主页" },
    { idx: 5, value: "邮件" },
  ],
  [
    { idx: 6, value: "刷新" },
    { idx: 7, value: "切换应用" },
    { idx: 8, value: "复制" },
  ],
  [
    { idx: 9, value: "剪切" },
    { idx: 10, value: "粘贴" },
  ],
];

export const key_value = ["01", "08", "04", "02"];

export const key_map = {
  "01": [0],
  "08": [1],
  "04": [2],
  "02": [3],
  "09": [0, 1],
  "05": [0, 2],
  "0c": [1, 2],
  "06": [2, 3],
  "03": [0, 3],
  "0a": [1, 3],
  "0d": [0, 1, 2],
  "0b": [0, 1, 3],
  "07": [0, 2, 3],
  "0e": [1, 2, 3],
  "0f": [0, 1, 2, 3],
};

export const macro_key = {
  65: "04",
  66: "05",
  67: "06",
  68: "07",
  69: "08",
  70: "09",
  71: "0A",
  72: "0B",
  73: "0C",
  74: "0D",
  75: "0E",
  76: "0F",
  77: "10",
  78: "11",
  79: "12",
  80: "13",
  81: "14",
  82: "15",
  83: "16",
  84: "17",
  85: "18",
  86: "19",
  87: "1A",
  88: "1B",
  89: "1C",
  90: "1D",

  48: "27",
  49: "1E",
  50: "1F",
  51: "20",
  52: "21",
  53: "22",
  54: "23",
  55: "24",
  56: "25",
  57: "26",

  96: "27",
  97: "1E",
  98: "1F",
  99: "20",
  100: "21",
  101: "22",
  102: "23",
  103: "24",
  104: "25",
  105: "26",

  27: "29",
  32: "2C",
  9: "2B",
  8: "2A",
  189: "2D",
  187: "2E",
  219: "2F",
  221: "30",
  220: "31",
  186: "33",
  222: "34",
  192: "35",
  188: "36",
  190: "37",
  191: "38",
  20: "39",

  112: "3A",
  113: "3B",
  114: "3C",
  115: "3D",
  116: "3E",
  117: "3F",
  118: "40",
  119: "41",
  120: "42",
  121: "43",
  122: "44",
  123: "45",

  44: "46",
  145: "47",
  19: "48",

  45: "49",
  36: "4A",
  33: "4B",
  46: "4C",
  35: "4D",
  34: "4E",

  39: "4F",
  37: "50",
  40: "51",
  38: "52",

  144: "53",
  111: "54",
  106: "55",
  109: "56",
  107: "57",

  13: "58",
  35: "59",
  16: "E1",
  17: "E0",
  18: "E2",
};

export const macroBaseData =
  "000000000000000000000000000000000000000000000000000000000000000000000000";

export const dataNum = 40;

export const macro_key_map = {
  1: "02",
  2: "03",
  3: "05",
  0: "01",
  4: "04",
};

export const mouseEventValue = [
  {
    label: "左键",
    value: 1,
  },
  {
    label: "右键",
    value: 2,
  },
  {
    label: "中键",
    value: 4,
  },
  {
    label: "前进",
    value: 16,
  },
  {
    label: "后退",
    value: 8,
  },
  // {
  //   label: "向上滚动",
  //   value: 5,
  // },
  // {
  //   label: "向下滚动",
  //   value: 6,
  // },
];
export const gameEventValue = [
  {
    label: "左键",
    value: 1,
  },
  {
    label: "右键",
    value: 2,
  },
  {
    label: "中键",
    value: 4,
  },
  {
    label: "前进",
    value: 8,
  },
  {
    label: "后退",
    value: 16,
  },
];
export const eventOptions = [
  {
    label: "插入鼠标事件",
    value: 0,
  },
  {
    label: "插入键盘事件",
    value: 1,
  },
  {
    label: "插入时间延迟",
    value: 2,
  },
];
export const gameKey = [
  { label: "键盘按键", value: 3 },
  { label: "鼠标按键", value: 1 },
];
